import { render, staticRenderFns } from "./ProtectedUrls.vue?vue&type=template&id=1cbe13c6&"
import script from "./ProtectedUrls.vue?vue&type=script&lang=js&"
export * from "./ProtectedUrls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbe13c6')) {
      api.createRecord('1cbe13c6', component.options)
    } else {
      api.reload('1cbe13c6', component.options)
    }
    module.hot.accept("./ProtectedUrls.vue?vue&type=template&id=1cbe13c6&", function () {
      api.rerender('1cbe13c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/security/ProtectedUrls.vue"
export default component.exports